export const SET_CAMPAGNA = "SET_CAMPAGNA";

export const RESET_PERSISTENT_STORE_STATE = "RESET_PERSISTENT_STORE_STATE";


export const GET_CAMPAGNE_ATTIVE_SCREENING = "GET_CAMPAGNE_ATTIVE_SCREENING"
export const GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS = "GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS"